import ViewBase from "../../../../framework/core/mvvm/view_base";
import { IUserData } from "../../../public/model_data";
import GameUtil from "../../../../utility/game_util";

const { ccclass, property } = cc._decorator;

@ccclass
export default class OhterChatInfoView extends ViewBase {
    

    @property(cc.Button)
    btnClose: cc.Button = null;
   

    @property([cc.Button])
    emojiBtnList: cc.Button[] = []

   

    @property(cc.Label)
    playerNameTxt:cc.Label = null;

    @property(cc.Label)
    baseInfoID:cc.Label = null;

    @property(cc.Sprite)
    baseInfoSprite:cc.Sprite = null;

    @property(cc.Node)
    male:cc.Node = null;
    
    @property(cc.Node)
    female:cc.Node = null;

    @property(cc.Button)
    addFriendBtn:cc.Button = null;
    
    @property([cc.Node])
    friendBtn:cc.Node[] = [];

    playerId=0

    onInit() {
        this.node.position=new cc.Vec2(0,0)
    }

    onShow(arg0) 
    {
        super.onShow(arg0)
        this.node.position=new cc.Vec2(0,0)
        
    }

    currencyFormatting(money:number){
        return Math.floor(money * 1000 / 10) / 100
    }
    refreshPlayerInfo(playerId:number)
    {
        this.baseInfoID.string = "ID:"+playerId.toString();
        this.getUserData(playerId, (data : IUserData)=> {
            this.playerNameTxt.string = GameUtil.cutStr(data.name) 
           
            this.baseInfoSprite.spriteFrame = data.avatarSprite
            if(data.gender == 1)
            {
                this.male.active=true
                this.female.active=false
            }
            else
            {
                this.male.active=false
                this.female.active=true
            }
        })
    }
    refreshPlayerBaseInfoIcon(spriteFrame: cc.SpriteFrame){
        if (!spriteFrame) {
            return;
        }
        this.baseInfoSprite.spriteFrame = spriteFrame;
    }

    refreshFriendBtn(tag:number){
        this.friendBtn[0].active = tag == 0;//删除
        this.friendBtn[1].active = tag == 1;//添加
    }
}